export const LayoutStyle = {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden'
    //overflowY: 'auto'
};
